module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alisa Valdes-Rodriguez\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("ALISA VALDES-RODRIGUEZ is an award-winning print and broadcast journalist and a former staff writer for both the "), _c('I', [_vm._v("Los Angeles Times")]), _vm._v(" and the"), _c('I', [_vm._v(" Boston Globe")]), _vm._v(". She is the bestselling author of "), _c('I', [_vm._v("The Dirty Girls Social Club")]), _vm._v(" and "), _c('I', [_vm._v("Playing with Boys")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UAUzGA/e9781429919197_cover.jpg?1718046010842",
      "alt": "This image is the cover for the book Make Him Look Good"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Make Him Look Good\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The \"him\" in "), _c('i', [_vm._v("Make Him Look Good")]), _vm._v(" is Ricky Biscayne, sexy Latin singing sensation who has taken the pop world by storm. But it takes more than swiveling hips and dreamy eyes to get to the top of the charts. The women who orbit Ricky are:"), _c('br'), _c('br'), _vm._v(" -- Milan, Ricky's new publicist, and her sister Geneva whose Club G promises to have Miami's hottest opening ever"), _c('br'), _vm._v(" -- Jill Sanchez, a media-manic Latina star who has crossed over from CDs to perfume, clothes and movies"), _c('br'), _vm._v(" -- Jasminka, Ricky's gorgeous Croatian model wife"), _c('br'), _vm._v(" -- Irene, a firefighter whose high school romance with Ricky was the last love in her life, eking out an existence for herself and her daughter Sophia, who is beginning to suspect that she and Ricky Biscayne look a little too much alike"), _c('br'), _c('br'), _vm._v("With several satisfying romances set against Miami's music, club and modeling scenes, "), _c('i', [_vm._v("Make Him Look Good")]), _vm._v("is irresistible fiction from one of America's most original voices.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0